<template>
  <div class="shippingDetail custSupport">
    <section class="main_section">
      <div class="preorder_row cust_support">
        <h3>किसी भी सहायता के लिए आप हमारे ग्राहक सहायता केंद्र से संपर्क कर सकते हैं।</h3>
        <div class="support_detail">
          <h5>
            ईमेल करें :
            <span>
              <a href="mailto:help@mall91.com">help@mall91.com</a>
            </span>
          </h5>
          <h5>
            कॉल करें :
            <span>
              <a href="tel:011-43092005">011-43092005</a>
            </span>
          </h5>
        </div>
        <p>* कॉलिंग घंटे सोमवार से शनिवार, सुबह 10 से शाम 7 बजे तक हैं।</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CustSupport",
};
</script>
